import JinkongIndex from '../components/jinkong/Index';
import JinkongImportPerson from '../components/jinkong/detail/ImportPerson';
import JinkongSettleDetail from '../components/jinkong/detail/SettleDetails';

export default [
	{
		path:'',
		component:JinkongIndex,
	},
	{
		path:'import-person/:type/:id',
		component:JinkongImportPerson,
	},
	{
		path:'settle-detail/:id',
		component:JinkongSettleDetail,
	},
]


// WEBPACK FOOTER //
// ./src/pages/haierProduct/router/jinkong.js